import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StepperService {
  private _step: WritableSignal<number> = signal(0);
  private _isVisible: WritableSignal<boolean> = signal(true);

  get step(): WritableSignal<number> {
    return this._step;
  }

  get isVisible(): WritableSignal<boolean> {
    return this._isVisible;
  }

  public initStepper() {
    this._step.set(0);
    this._isVisible.set(true);
  }
}
